module.exports = __webpack_public_path__ + "media/device.db8aacb7.mp4";